import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";

/**
 * Api is a generic REST Api handler. Set your API url first.
 */
@Injectable()
export class Api {
  constructor(public http: HttpClient) {}

  get(endpoint: string, params?: any, reqOpts?: any) {
    if (!reqOpts) {
      reqOpts = {
        params: new HttpParams(),
      };
    }

    // Support easy query params for GET requests
    if (params) {
      reqOpts.params = new HttpParams();
      for (let k in params) {
        reqOpts.params = reqOpts.params.set(k, params[k]);
      }
    }

    return this._request("GET", endpoint, null, reqOpts);
  }

  post(endpoint: string, body: any, reqOpts?: any) {
    return this._request("POST", endpoint, body, reqOpts);
  }

  put(endpoint: string, body: any, reqOpts?: any) {
    return this._request("PUT", endpoint, body, reqOpts);
  }

  delete(endpoint: string, reqOpts?: any) {
    return this._request("DELETE", endpoint, null, reqOpts);
  }

  patch(endpoint: string, body: any, reqOpts?: any) {
    return this._request("PATCH", endpoint, body, reqOpts);
  }

  private _request(
    method: string,
    endpoint: string,
    body?: any,
    reqOpts?: any
  ) {
    const url = environment.useMocks ? endpoint : environment.apiUrl + endpoint;
    method = environment.useMocks ? "GET" : method;
    return this.http.request(method, url, { body, ...reqOpts });
  }
}



// WEBPACK FOOTER //
// ./src/app/providers/api/api.ts